export default __webpack_public_path__ + "static/media/1.c6a499c9.png";